import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { KRollService } from '../../services/api-services/kroll.service';
import { HelperService } from '../../services/helper.service';
import { numericAlpha, spaceValidator } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
@Component({
  selector: 'app-add-note-popup',
  templateUrl: './add-note-popup.component.html',
  styleUrls: ['./add-note-popup.component.scss']
})
export class AddNotePopupComponent {
  warning: boolean = false;
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  constructor(public dialogRef: MatDialogRef<AddNotePopupComponent>,
    private fb: FormBuilder,
    public toast: ToastrService,
    public krollService: KRollService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
    this.initializeForm();
  }
  initializeForm() {
    this.form = this.fb.group({
      SalesOrderID: new FormControl(this.props.ID, Validators.compose([Validators.required])),
      Notes: new FormControl(this.props.Notes, Validators.compose([Validators.required, spaceValidator, numericAlpha])),
    });
  }
  formSubmit() {
    if (this.form.valid) {
      let obj = {
        ...this.form.value,
        Notes: this.helperService.getBase64(this.form.value.Notes)
      }
      this.isLoading = true;
      this.krollService.save_sales_order_notes(obj).subscribe(res => {
        this.isLoading = false;
        if (res.body.success) {
          this.dialogRef.close(this.form.value);
          this.toast.success(res.body.message[0]);
        }
        else {
          this.toast.error(res.body.message[0]);
        }
      })
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
}
